
<template>
  <div>
  <vx-card>
      <div class="p-6">
        <div class="flex flex-wrap items-center mb-4">    
              <vs-input v-model="serverParams.invoiceNumber" placeholder="송장번호" />
              <vs-select class="ml-4" v-model="serverParams.orderStatus" name="item-orderStatus">
                <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in statusOptions" />
              </vs-select>
              
              <vs-button class="ml-4" color="primary" type="border" icon-pack="feather" icon="icon-search" @click="onSearch"></vs-button>
            
        </div>

        <vue-good-table
          mode="remote"
          isLoading.sync="isLoading"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          @on-sort-change="onSortChange"
          @on-row-click="onRowClick"
          :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            nextLabel: '',
            prevLabel: '',
            rowsPerPageLabel: '',
            perPage: 20
          }"
          :sort-options="{
            enabled: true,
            //initialSortBy: {field: 'orderName', type: 'asc'}
          }"
          :columns="columns"
          :rows="rows"
          :totalRows="totalRecords"
          :fix-header="true"
          :line-numbers="false"
          styleClass="vgt-table condensed"
          />
      </div>
    </vx-card> 
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { fetchData } from '@/api/module'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      isLoading: false,
      order_data : null,
      columns: [
        {
          label: '학원명',
          field: 'instituteName',
          type: 'name',
          sortable: false
        },
        {
          label: '주문일',
          field: 'orderCreateDate',
          type: 'date',
          formatFn: this.formatterDate,
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd'
        },
        {
          label: '주문금액',
          field: 'buyMoney',
          formatFn: this.buyMoney,
          type: 'name'
        },
        {
          label: '상태',
          field: 'orderStatus',
          formatFn: this.orderStatus,
          type: 'name'
        },
        {
          label: '배송방법',
          field: 'deliverWay',
          type: 'name'
        },
        {
          label: '송장번호',
          field: 'invoiceNumber',
          type: 'name'
        },
        {
          label: '배송일',
          field: 'deliverFixedDate',
          type: 'date',
          formatFn: this.formatterDate,
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd'
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 20,
        field: 'OrderCreateDate',
        type: 'DESC',
        orderStatus: '',
        invoiceNumber: ''
      },
      statusOptions: [
        {
          value: '',
          text: '[상태]'
        },
        {
          value: '0',
          text: '주문'
        },
        {
          value: '1',
          text: '결제완료'
        },
        {
          value: '2',
          text: '배송중'
        },
        {
          value: '3',
          text: '배송완료'
        },
        {
          value: '4',
          text: '거래완료'
        }
      ]
    }
  },
  
  methods: {
    buyMoney (value) {
      return `${String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')  }원`
    },
    formatterDate (value) {
      if (value === null || value === undefined) return
      return value.split(' ')[0]
    },
    orderStatus (value) {
      if (value === 0) {
        return '주문'
      } else if (value === 1) {
        return '결제완료'
      } else if (value === 2) {
        return '배송중'
      } else if (value === 3) {
        return '배송완료'
      } else if (value === 4) {
        return '거래완료'
      } else {
        return ''
      }
    },
    onAdd () {
      this.$router.push('/book/order/order-add')
    },
    
    updateParams () {
      const newObj = Object.assign({}, this.serverParams)
      this.$store.dispatch('setOrderSheetParams', newObj)
    },

    onRowClick (params) {
      const orderSheetSeq = params.row.orderSheetSeq
      this.$router.push(`/ordersheet/ordersheet-view/${orderSheetSeq}`)
    },

    onPageChange (params) {
      this.serverParams.page = params.currentPage
      this.loadItems()
    },

    onPerPageChange (params) {
      this.serverParams.perPage = params.currentPerPage
      this.serverParams.page = 1
      this.loadItems()
    },

    onSortChange (params) {
      this.serverParams.field = params[0].field
      this.serverParams.type = params[0].type
      this.loadItems()
    },

    onSearch () {
      this.serverParams.page = 1
      this.loadItems()
    },

    async loadItems () { 
      try {
        this.updateParams()
        const { data } = await fetchData('order', this.serverParams)
        this.$vs.loading.close()
        this.totalRecords = data.count 
        this.rows = data.list 
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    }
  },
  created () {
    const params = this.$store.getters.getOrderSheetParams
    this.serverParams = Object.assign({}, params)
    this.loadItems()
  }
}
</script>
